// @ts-nocheck
import { debugLog } from '../../debug-log';
import { isValid } from '@cloud20x/vin-decoder';

export const identifyVinNumber = (vinNumber: any) => {
  if (!vinNumber) return null;

  let sanitizedVin = vinNumber.replace('WIN', 'W1N');

  sanitizedVin = sanitizedVin.replaceAll(/[^a-zA-Z0-9]/g, '');
  sanitizedVin = sanitizedVin.replaceAll('O','0').replaceAll('o','0');
  sanitizedVin = sanitizedVin.replaceAll('Q','0').replaceAll('q','0');
  sanitizedVin = sanitizedVin.replaceAll('I','1').replaceAll('i','1');

  // OCR can leave junk before/after the real VIN, so don't just trust the
  // first 17 chars - slide a 17-char window across and keep the first one
  // that passes the VIN checksum.
  for (let start = 0; start <= sanitizedVin.length - 17; start++) {
    const candidate = sanitizedVin.slice(start, start + 17);
    if (isValid(candidate)) {
      debugLog({ vinNumber, sanitizedVin: candidate });
      return candidate;
    }
  }

  debugLog({ vinNumber, sanitizedVin: sanitizedVin.slice(0, 17) });
  return null;
};
